/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable eqeqeq */
/* eslint-disable no-var */
/* eslint-disable no-tabs */
import { EventDispatcher, MOUSE, Quaternion, Spherical, TOUCH, Vector2, Vector3 } from 'three/build/three.module';
import store from '@blade-sxp/map/src/store';

// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move

let OrbitControls = function (object, domElement) {
  if (domElement === undefined) console.warn('THREE.OrbitControls: The second parameter "domElement" is now mandatory.');
  if (domElement === document)
    console.error(
      'THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.'
    );
  var scope = this;
  this.object = object;
  object.rotation.order = 'YXZ';
  this.domElement = domElement;

  this.pressKeys = [];

  // Set to false to disable this control
  this.enabled = true;

  // "target" sets the location of focus, where the object orbits around
  this.target = new Vector3();

  // How far you can dolly in and out ( PerspectiveCamera only )
  this.minDistance = 0;
  this.maxDistance = Infinity;

  // How far you can zoom in and out ( OrthographicCamera only )
  this.minZoom = 0;
  this.maxZoom = Infinity;

  this.onViewChange = null;

  // How far you can orbit vertically, upper and lower limits.
  // Range is 0 to Math.PI radians.
  this.minPolarAngle = 0; // radians
  this.maxPolarAngle = Math.PI; // radians

  // How far you can orbit horizontally, upper and lower limits.
  // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
  this.minAzimuthAngle = -Infinity; // radians
  this.maxAzimuthAngle = Infinity; // radians

  // Set to true to enable damping (inertia)
  // If damping is enabled, you must call controls.update() in your animation loop
  this.enableDamping = false;
  this.dampingFactor = 0.05;

  // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
  // Set to false to disable zooming
  this.enableZoom = true;
  this.zoomSpeed = 1.0;

  // Set to false to disable rotating
  this.enableRotate = true;
  this.rotateSpeed = 1.0;

  // Set to false to disable panning
  this.enablePan = true;
  this.panSpeed = 1.0;
  this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
  this.keyPanSpeed = 7.0; // pixels moved per arrow key push

  // Set to true to automatically rotate around the target
  // If auto-rotate is enabled, you must call controls.update() in your animation loop
  this.autoRotate = false;
  this.autoRotateSpeed = 2.0; // 30 seconds per round when fps is 60

  // Set to false to disable use of the keys
  this.enableKeys = true;
  // 是否第三人称
  this.isThirdPerspective = true;

  // The four arrow keys
  this.keys = { LEFT: [37], UP: [38], RIGHT: [39], BOTTOM: [40], RISE: [], FALL: [], UPSHIFT: [], SWITCH: [] };

  // Mouse buttons
  this.mouseButtons = { LEFT: MOUSE.ROTATE, MIDDLE: MOUSE.DOLLY, RIGHT: MOUSE.PAN };

  // Touch fingers
  this.touches = { ONE: TOUCH.ROTATE, TWO: TOUCH.DOLLY_PAN };

  this.interval = 20;
  // for reset
  this.target0 = this.target.clone();
  this.position0 = this.object.position.clone();
  this.zoom0 = this.object.zoom;
  // 碰撞检测
  this._capsuleEnable = false;

  //仅用于飞行模式加速
  this.shiftKey = false;

  let preClientX = -1;
  let preClientY = -1;
  let lastHandleTime = 0;

  Object.defineProperty(this, 'capsuleEnable', {
    get() {
      return this._capsuleEnable;
    },
    set(val) {
      this._capsuleEnable = val;
      if (!val) {
        // 每次切换获取最新视角位置
        this.target.copy(getTargetPosition());
      }
    },
  });

  //
  // public methods
  //
  this.getFrameSpeed = function () {
    let speed = this.keyPanSpeed;
    if (this.shiftKey) {
      speed *= 2;
    }
    const frameSpeed = speed / 10;
    return frameSpeed;
  };

  this.getPolarAngle = function () {
    return spherical.phi;
  };

  this.getAzimuthalAngle = function () {
    return spherical.theta;
  };

  this.saveState = function () {
    scope.target0.copy(scope.target);
    scope.position0.copy(scope.object.position);
    scope.zoom0 = scope.object.zoom;
  };

  this.reset = function () {
    scope.target.copy(scope.target0);
    scope.object.position.copy(scope.position0);
    scope.object.zoom = scope.zoom0;

    scope.object.updateProjectionMatrix();
    scope.dispatchEvent(changeEvent);

    scope.update();

    state = STATE.NONE;
  };

  // 检查是否碰撞
  function checkCapsule(position) {
    // 如果允许碰撞检测才进行检测
    const playerCollider = store.capsule;
    if (!scope.capsuleEnable || !playerCollider || !store.worldOctree) return false;
    const { x, y, z } = position;
    let direction = new Vector3();
    // 第三人称则用相机下前方的模型作为碰撞检测；
    if (scope.isThirdPerspective) direction = scope.object.getWorldDirection(new Vector3()).normalize().multiplyScalar(1);
    else direction = scope.object.getWorldDirection(new Vector3()).normalize().multiplyScalar(1);
    playerCollider.start.set(x + direction.x, y + direction.y - 0.35, z + direction.z);
    playerCollider.end.set(x + direction.x, y + direction.y + 0.35, z + direction.z);
    playerCollider.radius = 3.5;
    const result = store.worldOctree.capsuleIntersect(playerCollider);
    return result;
  }

  // this method is exposed, but perhaps it would be better if we can make it private...
  this.update = (function () {
    let offset = new Vector3();

    // so camera.up is the orbit axis
    let quat = new Quaternion().setFromUnitVectors(object.up, new Vector3(0, 1, 0));
    let quatInverse = quat.clone().invert();

    let lastPosition = new Vector3();
    let lastQuaternion = new Quaternion();

    let twoPI = 2 * Math.PI;
    return function update() {
      // 更新键盘事件
      if (store.mode !== 'travel') scope.handleKeyDown();

      let position = scope.object.position;
      offset.copy(position).sub(scope.target);
      // 相机朝向
      // const direction = offset.clone().normalize();
      // rotate offset to "y-axis-is-up" space
      offset.applyQuaternion(quat);

      // angle from z-axis around y-axis
      spherical.setFromVector3(offset);

      if (scope.autoRotate && state === STATE.NONE && !scope.capsuleEnable) {
        rotateLeft(getAutoRotationAngle());
      }

      if (scope.enableDamping) {
        spherical.theta += sphericalDelta.theta * scope.dampingFactor;
        spherical.phi += sphericalDelta.phi * scope.dampingFactor;
      } else {
        spherical.theta += sphericalDelta.theta;
        spherical.phi += sphericalDelta.phi;
      }
      // restrict theta to be between desired limits

      let min = scope.minAzimuthAngle;
      let max = scope.maxAzimuthAngle;

      if (isFinite(min) && isFinite(max)) {
        if (min < -Math.PI) min += twoPI;
        else if (min > Math.PI) min -= twoPI;

        if (max < -Math.PI) max += twoPI;
        else if (max > Math.PI) max -= twoPI;

        if (min <= max) {
          spherical.theta = Math.max(min, Math.min(max, spherical.theta));
        } else {
          spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
        }
      }

      // restrict phi to be between desired limits
      spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));

      spherical.makeSafe();

      spherical.radius *= scale;

      // restrict radius to be between desired limits
      spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));

      // move target to panned location

      if (scope.enableDamping === true) {
        scope.target.addScaledVector(panOffset, scope.dampingFactor);
      } else {
        scope.target.add(panOffset);
      }

      offset.setFromSpherical(spherical);

      // rotate offset back to "camera-up-vector-is-up" space
      offset.applyQuaternion(quatInverse);
      const targetPosition = position.clone().copy(scope.target).add(offset);
      // const speed = this.getFrameSpeed();
      // const nextPosition = targetPosition.clone().add(direction.multiplyScalar(speed));
      // const length = targetPosition.length();
      // // leng为相机到远点的位置，离远点越远，near应该越大
      // let near = 1;
      // if (length > 500) {
      //   // 设置太大的话 飞行模式下看不到近端面的飞机， 设置太小会闪面
      //   near = 20;
      // } else if (length > 200) {
      //   near = 10;
      // } else if (length > 100) {
      //   near = 1;
      // } else if (length > 10) {
      //   near = 0.1;
      // } else {
      //   near = 0.01;
      // }
      // if (scope.object.near !== near) {
      //   scope.object.near = near;
      //   scope.object.updateProjectionMatrix();
      // }
      if (store.mode !== 'travel') {
        // 延当前位置前进1帧进行检测
        let result = checkCapsule(targetPosition);
        if (result) {
          // 下一帧如果碰撞，则先移动到下一帧碰撞后反弹的位置上
          targetPosition.add(result.normal.multiplyScalar(result.depth));
          panOffset.set(0, 0, 0);
          sphericalDelta.set(0, 0, 0);
        }
      }

      position.copy(targetPosition);
      if (!scope.capsuleEnable) scope.object.lookAt(scope.target);

      if (scope.enableDamping === true) {
        sphericalDelta.theta *= 1 - scope.dampingFactor;
        sphericalDelta.phi *= 1 - scope.dampingFactor;

        panOffset.multiplyScalar(1 - scope.dampingFactor);
      } else {
        sphericalDelta.set(0, 0, 0);

        panOffset.set(0, 0, 0);
      }

      scale = 1;

      // update condition is:
      // min(camera displacement, camera rotation in radians)^2 > EPS
      // using small-angle approximation cos(x/2) = 1 - x^2 / 8
      if (
        zoomChanged ||
        lastPosition.distanceToSquared(scope.object.position) > EPS ||
        8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS
      ) {
        scope.dispatchEvent(changeEvent);

        lastPosition.copy(scope.object.position);
        lastQuaternion.copy(scope.object.quaternion);
        zoomChanged = false;
        return true;
      }

      return false;
    };
  })();

  this.dispose = function () {
    scope.domElement.removeEventListener('contextmenu', onContextMenu, false);

    scope.domElement.removeEventListener('pointerdown', onPointerDown, false);
    scope.domElement.removeEventListener('wheel', onMouseWheel, false);

    scope.domElement.removeEventListener('touchstart', onTouchStart, false);
    scope.domElement.removeEventListener('touchend', onTouchEnd, false);
    scope.domElement.removeEventListener('touchmove', onTouchMove, false);

    scope.domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, false);
    scope.domElement.ownerDocument.removeEventListener('pointerup', onPointerUp, false);

    scope.domElement.removeEventListener('keydown', onKeyDown, false);
    // scope.domElement.removeEventListener('keypress', onKeyPress, false);
    scope.domElement.removeEventListener('keyup', onKeyUp, false);

    // scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
  };

  this.handleTravelKeyDown = function () {};
  this.handleTravelKeyUp = function () {};

  //
  // internals
  //

  var changeEvent = { type: 'change' };
  let startEvent = { type: 'start' };
  let endEvent = { type: 'end' };

  var STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6,
  };

  var state = STATE.NONE;

  var EPS = 0.000001;

  // current position in spherical coordinates
  var spherical = new Spherical();
  var sphericalDelta = new Spherical();

  var scale = 1;
  var panOffset = new Vector3();
  var zoomChanged = false;

  let rotateStart = new Vector2();
  let rotateEnd = new Vector2();
  let rotateDelta = new Vector2();

  let panStart = new Vector2();
  let panEnd = new Vector2();
  let panDelta = new Vector2();

  let dollyStart = new Vector2();
  let dollyEnd = new Vector2();
  let dollyDelta = new Vector2();

  function getAutoRotationAngle() {
    return ((2 * Math.PI) / 60 / 60) * scope.autoRotateSpeed;
  }

  function getZoomScale() {
    return Math.pow(0.95, scope.zoomSpeed);
  }

  function rotateLeft(angle) {
    sphericalDelta.theta -= angle;
  }

  function rotateUp(angle) {
    sphericalDelta.phi -= angle;
  }

  let panLeft = (function () {
    let v = new Vector3();

    return function panLeft(distance, objectMatrix) {
      v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
      v.multiplyScalar(-distance);
      panOffset.add(v);
    };
  })();

  let panUp = (function () {
    let v = new Vector3();

    return function panUp(distance, objectMatrix) {
      if (scope.screenSpacePanning === true) {
        v.setFromMatrixColumn(objectMatrix, 1);
      } else {
        v.setFromMatrixColumn(objectMatrix, 0);
        v.crossVectors(scope.object.up, v);
      }
      v.multiplyScalar(distance);
      panOffset.add(v);
    };
  })();

  const panFly = function (type) {
    const frameSpeed = scope.getFrameSpeed();
    const position = scope.object.position.clone();
    const target = scope.target.clone();
    if (type === 'rise') {
      position.y += frameSpeed;
      target.y += frameSpeed;
    } else {
      position.y -= frameSpeed;
      target.y -= frameSpeed;
    }
    const result = checkCapsule(position);
    if (result) {
      const normal = result.normal;
      position.add(normal.multiplyScalar(frameSpeed));
      target.add(normal.multiplyScalar(frameSpeed));
    }
    scope.object.position.copy(position);
    scope.target.copy(target);
  };

  // deltaX and deltaY are in pixels; right and down are positive
  let pan = (function () {
    let offset = new Vector3();

    return function pan(deltaX, deltaY, type = '') {
      let element = scope.domElement;
      if (type) {
        panFly(type);
        return;
      }
      if (scope.object.isPerspectiveCamera) {
        // perspective
        let position = scope.object.position;
        // 相机位置到看的位置的差值
        offset.copy(position).sub(scope.target);
        let speed = scope.keyPanSpeed;
        if (scope.shiftKey) {
          speed *= 2;
        }
        // 固定差值
        if (scope.pressKeys.length) {
          offset = offset.normalize().multiplyScalar(speed * scope.interval);
        }
        let targetDistance = offset.length();
        // half of the fov is center to top of screen
        targetDistance *= Math.tan(((scope.object.fov / 2) * Math.PI) / 180.0);
        // we use only clientHeight here so aspect ratio does not distort speed
        panLeft((2 * deltaX * targetDistance) / element.clientHeight, scope.object.matrix);
        panUp((2 * deltaY * targetDistance) / element.clientHeight, scope.object.matrix);
      } else if (scope.object.isOrthographicCamera) {
        // orthographic
        panLeft((deltaX * (scope.object.right - scope.object.left)) / scope.object.zoom / element.clientWidth, scope.object.matrix);
        panUp((deltaY * (scope.object.top - scope.object.bottom)) / scope.object.zoom / element.clientHeight, scope.object.matrix);
      } else {
        // camera neither orthographic nor perspective
        console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
        scope.enablePan = false;
      }
    };
  })();

  function dollyOut(dollyScale) {
    if (scope.object.isPerspectiveCamera) {
      scale /= dollyScale;
    } else if (scope.object.isOrthographicCamera) {
      scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
      scope.object.updateProjectionMatrix();
      zoomChanged = true;
    } else {
      console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
      scope.enableZoom = false;
    }
  }

  function dollyIn(dollyScale) {
    if (scope.object.isPerspectiveCamera) {
      scale *= dollyScale;
    } else if (scope.object.isOrthographicCamera) {
      scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
      scope.object.updateProjectionMatrix();
      zoomChanged = true;
    } else {
      console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
      scope.enableZoom = false;
    }
  }

  //
  // event callbacks - update the object state
  //

  function handleMouseDownRotate(event) {
    rotateStart.set(event.clientX, event.clientY);
  }

  function handleMouseDownDolly(event) {
    dollyStart.set(event.clientX, event.clientY);
  }

  function handleMouseDownPan(event) {
    panStart.set(event.clientX, event.clientY);
  }

  function capsuleRotate(event) {
    const time = Date.now();
    if (time - lastHandleTime > 100) {
      preClientX = event.clientX;
      preClientY = event.clientY;
      lastHandleTime = time;
    }
    lastHandleTime = time;
    const y = (event.clientX - preClientX) / 500;
    const x = (event.clientY - preClientY) / 500;
    preClientX = event.clientX;
    preClientY = event.clientY;
    const angleY = ((scope.object.rotation.x - x) / Math.PI) * 180;
    if (angleY >= 90 || angleY <= -90) {
      return;
    }
    scope.object.rotation.y -= y;
    scope.object.rotation.x -= x;
  }

  function getTargetPosition() {
    // 切换到其他模式时视角不能发生变化, 默认点位是在地面
    // const distance = scope.object.position.length();
    const direction = scope.object.getWorldDirection(new Vector3()).normalize();
    const distance = Math.min(Math.abs(scope.object.position.y / direction.y), scope.maxDistance);
    return new Vector3().copy(scope.object.position.clone().add(direction.multiplyScalar(distance)));
  }

  function handleMouseMoveRotate(event) {
    if (scope.capsuleEnable) {
      // 如果是飞行模式，则不改变相机位置
      capsuleRotate(event);
      return;
    }
    rotateEnd.set(event.clientX, event.clientY);

    rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);

    let element = scope.domElement;

    rotateLeft((2 * Math.PI * rotateDelta.x) / element.clientHeight); // yes, height

    rotateUp((2 * Math.PI * rotateDelta.y) / element.clientHeight);

    rotateStart.copy(rotateEnd);

    scope.update();
  }

  function handleMouseMoveDolly(event) {
    dollyEnd.set(event.clientX, event.clientY);

    dollyDelta.subVectors(dollyEnd, dollyStart);

    if (dollyDelta.y > 0) {
      dollyOut(getZoomScale());
    } else if (dollyDelta.y < 0) {
      dollyIn(getZoomScale());
    }

    dollyStart.copy(dollyEnd);

    scope.update();
  }

  function handleMouseMovePan(event) {
    panEnd.set(event.clientX, event.clientY);

    panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
    pan(panDelta.x, panDelta.y);

    panStart.copy(panEnd);

    scope.update();
  }

  function handleMouseUp(/* event */) {
    // no-op
  }

  function handleMouseWheel(event) {
    if (event.deltaY < 0) {
      dollyIn(getZoomScale());
    } else if (event.deltaY > 0) {
      dollyOut(getZoomScale());
    }

    scope.update();
  }

  this.handleKeyDown = function (event = null) {
    const scope = this;
    let speed = scope.keyPanSpeed;
    if (this.shiftKey) {
      speed *= 2;
    }
    if (scope.pressKeys.some((e) => scope.keys.UP.includes(e))) {
      pan(0, speed);
    }
    if (scope.pressKeys.some((e) => scope.keys.BOTTOM.includes(e))) {
      pan(0, -speed);
    }
    if (scope.pressKeys.some((e) => scope.keys.LEFT.includes(e))) {
      pan(speed, 0);
    }
    if (scope.pressKeys.some((e) => scope.keys.RIGHT.includes(e))) {
      pan(-speed, 0);
    }
    if (scope.pressKeys.some((e) => scope.keys.RISE.includes(e))) {
      pan(0, speed, 'rise');
    }
    if (scope.pressKeys.some((e) => scope.keys.FALL.includes(e))) {
      pan(0, -speed, 'fall');
    }
  };

  function handleTouchStartRotate(event) {
    if (event.touches.length == 1) {
      rotateStart.set(event.touches[0].pageX, event.touches[0].pageY);
    } else {
      let x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
      let y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);

      rotateStart.set(x, y);
    }
  }

  function handleTouchStartPan(event) {
    if (event.touches.length == 1) {
      panStart.set(event.touches[0].pageX, event.touches[0].pageY);
    } else {
      let x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
      let y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);

      panStart.set(x, y);
    }
  }

  function handleTouchStartDolly(event) {
    let dx = event.touches[0].pageX - event.touches[1].pageX;
    let dy = event.touches[0].pageY - event.touches[1].pageY;

    let distance = Math.sqrt(dx * dx + dy * dy);

    dollyStart.set(0, distance);
  }

  function handleTouchStartDollyPan(event) {
    if (scope.enableZoom) handleTouchStartDolly(event);

    if (scope.enablePan) handleTouchStartPan(event);
  }

  function handleTouchStartDollyRotate(event) {
    if (scope.enableZoom) handleTouchStartDolly(event);

    if (scope.enableRotate) handleTouchStartRotate(event);
  }

  function handleTouchMoveRotate(event) {
    if (event.touches.length == 1) {
      rotateEnd.set(event.touches[0].pageX, event.touches[0].pageY);
    } else {
      let x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
      let y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);

      rotateEnd.set(x, y);
    }

    rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);

    let element = scope.domElement;

    rotateLeft((2 * Math.PI * rotateDelta.x) / element.clientHeight); // yes, height

    rotateUp((2 * Math.PI * rotateDelta.y) / element.clientHeight);

    rotateStart.copy(rotateEnd);
  }

  function handleTouchMovePan(event) {
    if (event.touches.length == 1) {
      panEnd.set(event.touches[0].pageX, event.touches[0].pageY);
    } else {
      let x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
      let y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);

      panEnd.set(x, y);
    }

    panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);

    pan(panDelta.x, panDelta.y);

    panStart.copy(panEnd);
  }

  function handleTouchMoveDolly(event) {
    let dx = event.touches[0].pageX - event.touches[1].pageX;
    let dy = event.touches[0].pageY - event.touches[1].pageY;

    let distance = Math.sqrt(dx * dx + dy * dy);

    dollyEnd.set(0, distance);

    dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));

    dollyOut(dollyDelta.y);

    dollyStart.copy(dollyEnd);
  }

  function handleTouchMoveDollyPan(event) {
    if (scope.enableZoom) handleTouchMoveDolly(event);

    if (scope.enablePan) handleTouchMovePan(event);
  }

  function handleTouchMoveDollyRotate(event) {
    if (scope.enableZoom) handleTouchMoveDolly(event);

    if (scope.enableRotate) handleTouchMoveRotate(event);
  }

  function handleTouchEnd(/* event */) {
    // no-op
  }

  //
  // event handlers - FSM: listen for events and reset state
  //

  function onPointerDown(event) {
    if (scope.enabled === false) return;
    switch (event.pointerType) {
      case 'mouse':
      case 'pen':
        onMouseDown(event);
        break;

      // TODO touch
    }
  }

  function onPointerMove(event) {
    if (scope.enabled === false) return;

    switch (event.pointerType) {
      case 'mouse':
      case 'pen':
        onMouseMove(event);
        break;

      // TODO touch
    }
  }

  function onPointerUp(event) {
    switch (event.pointerType) {
      case 'mouse':
      case 'pen':
        onMouseUp(event);
        break;

      // TODO touch
    }
  }

  function onMouseDown(event) {
    // Prevent the browser from scrolling.
    // event.preventDefault();

    // Manually set the focus since calling preventDefault above
    // prevents the browser from setting it automatically.

    scope.domElement.focus ? scope.domElement.focus() : window.focus();

    let mouseAction;

    switch (event.button) {
      case 0:
        mouseAction = scope.mouseButtons.LEFT;
        break;

      case 1:
        mouseAction = scope.mouseButtons.MIDDLE;
        break;

      case 2:
        mouseAction = scope.mouseButtons.RIGHT;
        break;

      default:
        mouseAction = -1;
    }

    switch (mouseAction) {
      case MOUSE.DOLLY:
        if (scope.enableZoom === false) return;

        handleMouseDownDolly(event);

        state = STATE.DOLLY;

        break;

      case MOUSE.ROTATE:
        //为了实现按下shift键的时候能鼠标旋转视角删除了 event.shiftKey 的判断
        if (event.ctrlKey || event.metaKey) {
          if (scope.enablePan === false) return;

          handleMouseDownPan(event);

          state = STATE.PAN;
        } else {
          if (scope.enableRotate === false) return;

          handleMouseDownRotate(event);

          state = STATE.ROTATE;
        }

        break;

      case MOUSE.PAN:
        if (event.ctrlKey || event.metaKey || event.shiftKey) {
          if (scope.enableRotate === false) return;

          handleMouseDownRotate(event);

          state = STATE.ROTATE;
        } else {
          if (scope.enablePan === false) return;

          handleMouseDownPan(event);

          state = STATE.PAN;
        }

        break;

      default:
        state = STATE.NONE;
    }

    if (state !== STATE.NONE) {
      scope.domElement.ownerDocument.addEventListener('pointermove', onPointerMove, false);
      scope.domElement.ownerDocument.addEventListener('pointerup', onPointerUp, false);

      scope.dispatchEvent(startEvent);
    }
  }

  function onMouseMove(event) {
    if (scope.enabled === false) return;

    event.preventDefault();

    switch (state) {
      case STATE.ROTATE:
        if (scope.enableRotate === false) return;

        handleMouseMoveRotate(event);

        break;

      case STATE.DOLLY:
        if (scope.enableZoom === false) return;

        handleMouseMoveDolly(event);

        break;

      case STATE.PAN:
        if (scope.enablePan === false) return;

        handleMouseMovePan(event);

        break;
    }
  }

  function onMouseUp(event) {
    scope.domElement.ownerDocument.removeEventListener('pointermove', onPointerMove, false);
    scope.domElement.ownerDocument.removeEventListener('pointerup', onPointerUp, false);

    if (scope.enabled === false) return;

    handleMouseUp(event);

    scope.dispatchEvent(endEvent);

    state = STATE.NONE;
  }

  function onMouseWheel(event) {
    if (scope.enabled === false || scope.enableZoom === false || (state !== STATE.NONE && state !== STATE.ROTATE)) return;

    event.preventDefault();
    event.stopPropagation();

    scope.dispatchEvent(startEvent);

    handleMouseWheel(event);

    scope.dispatchEvent(endEvent);
  }
  function onKeyDown(event) {
    if (scope.enabled === false || scope.enableKeys === false) return;
    if (store.mode === 'travel') {
      scope.handleTravelKeyDown(event);
    } else {
      if (!scope.pressKeys.includes(event.keyCode)) scope.pressKeys.push(event.keyCode);
      // 按下切换键时更新视角
      if (scope.keys.SWITCH.includes(event.keyCode)) {
        scope.isThirdPerspective = !scope.isThirdPerspective;
        scope.onViewChange && scope.onViewChange(scope.isThirdPerspective);
      }
    }

    event.preventDefault();
  }
  function onKeyUp(event) {
    if (scope.enabled === false || scope.enableKeys === false) return;
    if (store.mode === 'travel') {
      scope.handleTravelKeyUp(event);
    } else {
      if (event.keyCode === 16) scope.shiftKey = !scope.shiftKey;
      const index = scope.pressKeys.findIndex((e) => event.keyCode === e);
      if (index > -1) scope.pressKeys.splice(index, 1);
    }
  }

  function onTouchStart(event) {
    if (scope.enabled === false) return;

    event.preventDefault(); // prevent scrolling

    switch (event.touches.length) {
      case 1:
        switch (scope.touches.ONE) {
          case TOUCH.ROTATE:
            if (scope.enableRotate === false) return;

            handleTouchStartRotate(event);

            state = STATE.TOUCH_ROTATE;

            break;

          case TOUCH.PAN:
            if (scope.enablePan === false) return;

            handleTouchStartPan(event);

            state = STATE.TOUCH_PAN;

            break;

          default:
            state = STATE.NONE;
        }

        break;

      case 2:
        switch (scope.touches.TWO) {
          case TOUCH.DOLLY_PAN:
            if (scope.enableZoom === false && scope.enablePan === false) return;

            handleTouchStartDollyPan(event);

            state = STATE.TOUCH_DOLLY_PAN;

            break;

          case TOUCH.DOLLY_ROTATE:
            if (scope.enableZoom === false && scope.enableRotate === false) return;

            handleTouchStartDollyRotate(event);

            state = STATE.TOUCH_DOLLY_ROTATE;

            break;

          default:
            state = STATE.NONE;
        }

        break;

      default:
        state = STATE.NONE;
    }

    if (state !== STATE.NONE) {
      scope.dispatchEvent(startEvent);
    }
  }

  function onTouchMove(event) {
    if (scope.enabled === false) return;

    event.preventDefault(); // prevent scrolling
    event.stopPropagation();

    switch (state) {
      case STATE.TOUCH_ROTATE:
        if (scope.enableRotate === false) return;

        handleTouchMoveRotate(event);

        scope.update();

        break;

      case STATE.TOUCH_PAN:
        if (scope.enablePan === false) return;

        handleTouchMovePan(event);

        scope.update();

        break;

      case STATE.TOUCH_DOLLY_PAN:
        if (scope.enableZoom === false && scope.enablePan === false) return;

        handleTouchMoveDollyPan(event);

        scope.update();

        break;

      case STATE.TOUCH_DOLLY_ROTATE:
        if (scope.enableZoom === false && scope.enableRotate === false) return;

        handleTouchMoveDollyRotate(event);

        scope.update();

        break;

      default:
        state = STATE.NONE;
    }
  }

  function onTouchEnd(event) {
    if (scope.enabled === false) return;

    handleTouchEnd(event);

    scope.dispatchEvent(endEvent);

    state = STATE.NONE;
  }

  function onContextMenu(event) {
    if (scope.enabled === false) return;
    event.preventDefault();
  }

  //

  scope.domElement.addEventListener('contextmenu', onContextMenu, false);

  scope.domElement.addEventListener('pointerdown', onPointerDown, false);
  scope.domElement.addEventListener('wheel', onMouseWheel, false);

  scope.domElement.addEventListener('touchstart', onTouchStart, false);
  scope.domElement.addEventListener('touchend', onTouchEnd, false);
  scope.domElement.addEventListener('touchmove', onTouchMove, false);
  scope.domElement.addEventListener('keydown', onKeyDown, false);
  // scope.domElement.addEventListener('keypress', onKeyPress, false);
  scope.domElement.addEventListener('keyup', onKeyUp, false);
  scope.domElement.setAttribute('tabindex', '0');
  // force an update at start

  this.update();
};

OrbitControls.prototype = Object.create(EventDispatcher.prototype);
OrbitControls.prototype.constructor = OrbitControls;

// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
// This is very similar to OrbitControls, another set of touch behavior
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move

let MapControls = function (object, domElement) {
  OrbitControls.call(this, object, domElement);

  this.screenSpacePanning = false; // pan orthogonal to world-space direction camera.up

  this.mouseButtons.LEFT = MOUSE.PAN;
  this.mouseButtons.RIGHT = MOUSE.ROTATE;

  this.touches.ONE = TOUCH.PAN;
  this.touches.TWO = TOUCH.DOLLY_ROTATE;
};

MapControls.prototype = Object.create(EventDispatcher.prototype);
MapControls.prototype.constructor = MapControls;

export { OrbitControls, MapControls };
